import { guid } from '@atlassian/help-center-common-util/tiny-guid';

export const sessionId = guid();
